import React, { Component } from 'react'

export default class Default extends Component {
    render () {
        console.log(this.props)
        return (
            <div>
                Page Not Found
            </div>
        )
    }
}
